<template>
  <div>
    <!-- START : Buy it again Content Top Section -->
    <PlatformRenderer>
      <template v-slot:onMobile>
        <!-- START : Buy it again Content Top Section -->
        <div class="d-flex f-column justify-content-between px-lg-2 py-3 pt-lg-0">
          <div class="wc-buy-it-again-header">
            <!-- START : BUTTON SECTION TO ADD SELECTED -->
            <div class="wc-buy-it-again-header-btn">
              <button
                class="btn btn-link underline-link-from-center link-primary text-body text-nowrap font-weight-bold h4 m-0"
                @click="addSelectedToList(checkedItems)"
                :disabled="emptySelection"
                ref="addSelectedToListModalBtnRef"
              >
                <font-awesome-icon class="mr-2" icon="list-check" />{{ $t('addSelectedToList') }}
              </button>
              <button
                class="btn btn-link underline-link-from-center link-primary text-body text-nowrap font-weight-bold h4 m-0"
                @click="addSelectedToCart(checkedItems)"
                :disabled="emptySelection"
                v-if="!isCustomerModeScan && $configuration.cartEnabled"
              >
                <font-awesome-icon class="mr-2" icon="cart-shopping" />{{ $t('addSelectedToCart') }}
              </button>
            </div>
            <!-- END : BUTTON SECTION TO ADD SELECTED -->
            <div class="wc-buy-it-again-header-btn w-100 mt-3">
              <!-- START : Select All Products Checkbox -->
              <div v-if="items && items.length" class="w-50">
                <WCCheckbox
                  v-model="isAllSelected"
                  class="text-primary font-weight-bold"
                  :label="'Select All Items'"
                />
              </div>
              <!-- END : Select All Products Checkbox -->
              <!-- START : Item Count Display Section -->
              <div class="ml-4 font-size-sm text-right w-50" v-if="items">
                <div>
                  {{ items.length | items }}
                </div>
                <div class="text-dark" v-if="checkedItems.length">
                  {{ checkedItems.length | items }} {{ $t('selected') }}
                </div>
              </div>
              <!-- END : Item Count Display Section -->
            </div>
          </div>
        </div>
        <!-- END : Buy it again Content Top Section -->
      </template>
      <template v-slot:onDesktop>
        <!-- START : Buy it again Content Top Section -->
        <div class="d-flex justify-content-between px-lg-2 py-3 pt-lg-0">
          <!-- START : Select All Products Checkbox -->
          <div v-if="items && items.length">
            <WCCheckbox
              v-model="isAllSelected"
              class="text-primary font-weight-bold"
              :label="'Select All Items'"
            />
          </div>
          <!-- END : Select All Products Checkbox -->
          <div>
            <!-- START : BUTTON SECTION TO ADD SELECTED -->
            <div class="wc-buy-it-again-header-btn">
              <button
                class="btn btn-link underline-link-from-center link-primary text-body text-nowrap font-weight-bold h4 m-0"
                @click="addSelectedToList(checkedItems)"
                :disabled="emptySelection"
                ref="addSelectedToListModalBtnRef"
              >
                <font-awesome-icon class="mr-2" icon="list-check" />{{ $t('addSelectedToList') }}
              </button>
              <button
                class="btn btn-link underline-link-from-center link-primary text-body text-nowrap font-weight-bold h4 m-0"
                @click="addSelectedToCart(checkedItems)"
                :disabled="emptySelection"
                v-if="$configuration.cartEnabled"
              >
                <font-awesome-icon class="mr-2" icon="cart-shopping" />{{ $t('addSelectedToCart') }}
              </button>
            </div>
            <!-- END : BUTTON SECTION TO ADD SELECTED -->
            <!-- START : Item Count Display Section -->
            <div class="ml-4 font-size-sm text-right" v-if="items">
              <div>
                {{ items.length | items }}
              </div>
              <div class="text-dark" v-if="checkedItems.length">
                {{ checkedItems.length | items }} {{ $t('selected') }}
              </div>
            </div>
            <!-- END : Item Count Display Section -->
          </div>
        </div>
        <!-- END : Buy it again Content Top Section -->
      </template>
    </PlatformRenderer>
    <!-- END : Buy it again Content Top Section -->
    <!-- START : Buy it again Products -->
    <WCBuyItAgainItems
      v-if="items"
      :items="items"
      :checkedItems="checkedItems"
      @checkedListchange="onCheckedListChange"
      :isCustomerModeScan="isCustomerModeScan"
      :showQuantity="showQuantity"
    />
    <!-- END : Buy it again Products -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import WCBuyItAgainItems from '@/modules/user/components/WCBuyItAgainItems/WCBuyItAgainItems.vue';
import ItemCountMixin from '@/modules/lists/mixins/ItemCountMixin';
import WCCheckbox from '@/modules/forms/components/WCCheckbox/WCCheckbox.vue';
import ItemAddSelectedToCartMixin from '@/modules/lists/mixins/ItemAddSelectedToCartMixin';
import ItemAddSelectedToListMixin from '@/modules/lists/mixins/ItemAddSelectedToListMixin';
import PlatformRenderer from '@/modules/platform/components/PlatformRenderer';

export default {
  name: 'BuyItAgainSection',
  components: {
    WCBuyItAgainItems,
    WCCheckbox,
    PlatformRenderer,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    showQuantity: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checkedItems: [],
    };
  },
  mixins: [ItemCountMixin, ItemAddSelectedToCartMixin, ItemAddSelectedToListMixin], // Mixin for items filter
  methods: {
    /**
     * Methods to assign the checked list items
     * @param {Array} list
     */
    onCheckedListChange(list) {
      this.checkedItems = list;
    },
  },
  computed: {
    ...mapGetters({
      isCustomerModeScan: 'user/isCustomerModeScan',
      isGuest: 'user/isGuest',
    }),
    /**
     * Property to get and set isAllSelected computed value based on checkedItems
     */
    isAllSelected: {
      get() {
        return this.items.every(listItem => this.checkedItems.includes(listItem));
      },

      set(value) {
        if (value) {
          this.checkedItems = this.items.map(listItem => listItem);
        } else {
          this.checkedItems = [];
        }
      },
    },
    emptySelection() {
      return this.checkedItems.length === 0;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.wc-buy-it-again-header-btn {
  display: flex;
  gap: 1rem;
}

.f-column {
  flex-direction: column;
}

.wc-buy-it-again-header {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
</style>
